import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const BoldCardsIcon: FC<Props> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.688 18.1401C14.9289 18.1752 15.1643 18.1927 15.3932 18.1927C17.4499 18.1927 18.996 16.7952 19.3357 14.5401L20.2209 8.61398C20.5976 6.1069 19.2351 4.17859 16.8305 3.81582L12.7225 3.19745L12.7214 3.1969L12.7203 3.19635C10.3113 2.84593 8.44887 4.28867 8.07321 6.79644L7.18705 12.7225C6.81044 15.2296 8.17382 17.1589 10.5785 17.5207L14.688 18.1401ZM16.1403 10.192C16.1735 10.1966 16.2068 10.1994 16.24 10.1994C16.5788 10.1994 16.8741 9.95017 16.924 9.60586C16.9794 9.2274 16.7172 8.87663 16.3378 8.82217L12.1886 8.22124C11.8046 8.16678 11.4594 8.42986 11.4049 8.8074C11.3495 9.18586 11.6117 9.53663 11.9901 9.59201L16.1403 10.192ZM14.0043 13.2751C14.0375 13.2797 14.0708 13.2825 14.104 13.2825C14.4428 13.2825 14.7381 13.0342 14.788 12.6889C14.8434 12.3105 14.5812 11.9597 14.2018 11.9053L11.7132 11.5443C11.3366 11.4936 10.9831 11.7511 10.9286 12.1305C10.8741 12.5089 11.1363 12.8597 11.5148 12.9142L14.0043 13.2751Z"
        fill={props.fill || "currentColor" || "black"}
      />
      <path
        d="M12.7621 19.2498L10.3719 18.8905C7.19926 18.4114 5.32725 15.7908 5.81833 12.5167L6.70448 6.59142C6.72033 6.48563 6.61962 6.39801 6.51799 6.4314L5.19218 6.867C4.0891 7.22885 3.26018 7.90823 2.79587 8.83223C2.31033 9.79592 2.26326 10.9839 2.66018 12.1756L4.52941 17.8627C5.15895 19.7651 6.59156 20.8562 8.30203 20.8562C8.75618 20.8562 9.22972 20.7796 9.71339 20.6199L12.7923 19.6077C12.9771 19.547 12.9545 19.2787 12.7621 19.2498Z"
        fill={props.fill || "currentColor" || "black"}
      />
    </svg>
  );
};

export default BoldCardsIcon;
